import { gql } from '@apollo/client';

export const UPDATE_CONTROL_STATUS = gql`
  mutation updateToControlled($id: Int, $controlled: Boolean) {
    updateControlStatus(id: $id, controlled: $controlled) {
      controlled
    }
  }
`;
